import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { FormHelperText } from '@mui/material';

// ----------------------------------------------------------------------

RHFRadioGroups.propTypes = {
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  getOptionLabel: PropTypes.arrayOf(PropTypes.string),
};

export default function RHFRadioGroups({ label, name, options, required, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div>
          {/* <RadioGroup {...field} row {...other}>
            {options.map((option, index) => (
              <FormControlLabel
                key={option}
                value={option}
                control={<Radio />}
                label={getOptionLabel?.length ? getOptionLabel[index] : option}
              />
            ))}
          </RadioGroup> */}

          <FormControl error={error} fullWidth {...other}>
            <FormLabel
              sx={{
                borderBottom: '1px solid',
                pb: 1,
              }}
              id="demo-row-radio-buttons-group-label"
            >
              <>
                {label}
                {required ? <span className="text-primary-main">{' *'}</span> : ''}
              </>
            </FormLabel>
            <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
              {options.map((x) => (
                <FormControlLabel
                  key={x.value}
                  value={x.value}
                  checked={x.value === field.value || x.value === field.value?.value}
                  onChange={(e) => field.onChange(x)}
                  control={<Radio color={'success'} />}
                  label={x.label}
                />
              ))}

              {/* <FormControlLabel value="female" control={<Radio />} label="Female" />
              <FormControlLabel value="male" control={<Radio />} label="Male" />
              <FormControlLabel value="other" control={<Radio />} label="Other" />
              <FormControlLabel value="disabled" disabled control={<Radio />} label="other" /> */}
            </RadioGroup>
          </FormControl>

          {!!error && (
            <FormHelperText error sx={{ px: 2 }}>
              {error.message}
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}
